export default "__VITE_ASSET__C7E8zifw__"